import { Instagram, Mails, MapPin, MessageCircle } from "lucide-react";
import { Link } from "@remix-run/react";
import { Text3, Text4, Text5 } from "~/components/typographies/Texts";
import {
  EMAIL_ADDRESS,
  ADDRESS_GMAPS_LINK,
  INSTAGRAM_ID,
  SITE_URL,
  WHATSAPP_NUM,
  AUTHOR,
  ADDRESS,
} from "~/assets/profile/profile";
import { navLinks } from "../NavbarLinks";

export const Footer = () => {
  // Map menuData to create the products array
  const products2 = navLinks.map((item) => ({
    id: item.id,
    inaTitle: item.label,
    link: item.path,
  }));
  const products = [
    {
      id: 1,
      inaTitle: "Jasa Bangun Rumah",
      link: "/jasa-bangun-rumah-di-bekasi",
    },
    {
      id: 2,
      inaTitle: "Jasa Bangun Cluster",
      link: "/jasa-bangun-cluster-di-bekasi",
    },
    {
      id: 3,
      inaTitle: "Jasa Renovasi Rumah",
      link: "/jasa-renovasi-rumah-di-bekasi",
    },
    {
      id: 4,
      inaTitle: "Jasa Interior",
      link: "/jasa-interior-di-bekasi",
    },
    {
      id: 5,
      inaTitle: "Jasa Kontraktor",
      link: "/jasa-kontraktor-di-bekasi",
    },
  ];

  const corporate = [
    { id: 1, inaTitle: "Tentang Kami", usaTitle: "About Us", link: "/" },
    {
      id: 2,
      inaTitle: "Kerjasama",
      usaTitle: "Career",
      link: "/",
    },
  ];
  const support = [
    {
      id: 1,
      inaTitle: "Syarat dan Ketentuan",
      usaTitle: "Terms and Conditions",
      link: "/",
    },
    {
      id: 2,
      inaTitle: "Kebijakan Privasi",
      usaTitle: "Privacy Policy",
      link: "/privacy-policy",
    },
    {
      id: 3,
      inaTitle: "Layanan Konsultasi",
      usaTitle: "Consulting Services",
      link: "/",
    },
  ];

  const maps = [
    {
      id: 1,
      title: "Cabang Sendangguwo",
      address: ADDRESS,
    },
  ];
  const contacts = [
    {
      id: 1,
      inaTitle: ADDRESS,
      usTitle: ADDRESS,
      icon: <MapPin className="h-4 w-4 stroke-gray-300" />,
      link: ADDRESS_GMAPS_LINK,
    },
    {
      id: 2,
      inaTitle: WHATSAPP_NUM,
      usTitle: WHATSAPP_NUM,
      icon: <MessageCircle className="h-4 w-4 stroke-gray-300" />,
      link: `https://wa.me/${WHATSAPP_NUM}`,
    },
    {
      id: 3,
      inaTitle: "6281298582040",
      usTitle: "6281298582040",
      icon: <MessageCircle className="h-4 w-4 stroke-gray-300" />,
      link: `https://wa.me/6281298582040`,
    },
    {
      id: 4,
      inaTitle: INSTAGRAM_ID,
      usTitle: INSTAGRAM_ID,
      icon: <Instagram className="h-4 w-4 stroke-gray-300" />,
      link: "/",
    },
  ];
  const certified = [
    {
      id: 1,
      src: "https://ik.imagekit.io/didigi/didigi/pt-didigi-kreasi-solusindo/didigi-kominfo.webp?updatedAt=1737713825139",
      alt: "Certified KOMINFO",
    },
    {
      id: 2,
      src: "https://ik.imagekit.io/didigi/didigi/pt-didigi-kreasi-solusindo/didigi-ahu.webp?updatedAt=1737713824966",
      alt: "Certified AHU",
    },
    {
      id: 3,
      src: "https://ik.imagekit.io/didigi/didigi/pt-didigi-kreasi-solusindo/didigi-oss.webp?updatedAt=1737713825156",
      alt: "Certified OSS",
    },
    {
      id: 4,
      src: "https://ik.imagekit.io/didigi/didigi/pt-didigi-kreasi-solusindo/didigi-google-partner.webp?updatedAt=1737713824963",
      alt: "Certified GOOGLE",
    },
  ];

  return (
    <>
      <section className="pt-[5rem] lg:pt-[15rem] -mt-[2rem] flex flex-col  lg:flex-row h-full gap-y-[5rem]">
        <div
          className={`bg-black z-40 relative mx-auto px-6 lg:px-10 xl:px-15 w-full rounded-t-lg shadow-lg pt-[2rem] pb-[2rem] `}
        >
          <img
            className="w-full absolute -top-14 md:-top-36 lg:-top-36 xl:-top-52 right-0"
            src="https://ik.imagekit.io/didigi/didigi/JASA-RENOVASI-bangunrumahkita/jasa-renovasi-rumah-di-bekasi-footer.webp"
            alt="footer"
          />
          <div className=" flex flex-col lg:flex-row gap-[4rem]">
            <section className="lg:w-[30%] xl:w-[40%] flex flex-col gap-[1rem]">
              <img
                className="w-[15rem] z-30"
                src="https://ik.imagekit.io/didigi/didigi/JASA-RENOVASI-bangunrumahkita/jasa-bangun-rumah-arsinesia-logo-kecil.webp"
                alt="jasa renovasi rumah di bekasi | arsinesia.com"
                width={240} // 15rem × 16px = 240px
                height={240} // ganti sesuai rasio/aspek asli gambarmu
              />

              <Text3
                className=" z-50 typo-dark-primary"
                text={
                  "arsinesia.com berada di bawah bendera besar PT BAROKAH NUR THOIBAH. Digagas dan didirikan dalam rangka turut serta berperan dalam Pembangunan Nasional, khususnya bidang property rumah tinggal atau tempat usaha. Pada awalnya khusus pembangunan di bidang perumahan, yang telah dimulai sejak tahun 2010."
                }
              />
            </section>
            <section className=" z-20 w-full flex flex-col lg:flex-row gap-[1rem] lg:gap-[0rem]">
              <section className="w-full lg:w-[50%]">
                <p className="typo-dark-primary font-semibold text-[14px] lg:text-[18px]">
                  Menu
                </p>
                <div className="mt-[1rem] flex flex-col gap-y-[1rem]">
                  {products.map((item) => (
                    <div key={item.id} className="inline-block max-w-fit">
                      <Link to={item.link}>
                        <Text4
                          className="hover:underline text-white cursor-pointer"
                          text={item.inaTitle}
                        />
                      </Link>
                    </div>
                  ))}
                </div>
              </section>
              <section className="w-full flex flex-row gap-[1rem] mt-[1rem] lg:mt-0">
                <div className="w-full  flex flex-col gap-y-[1rem]">
                  <p className="heading-5-style typo-dark-primary font-semibold">
                    Perusahaan
                  </p>
                  {corporate.map((item) => (
                    <div key={item.id} className="inline-block max-w-fit">
                      <Link to={item.link}>
                        <Text4
                          className="hover:underline text-white cursor-pointer"
                          text={item.inaTitle}
                        />
                      </Link>
                    </div>
                  ))}
                </div>
                <div className="w-full flex flex-col gap-y-[1rem]">
                  <p className="heading-5-style typo-dark-primary font-semibold">
                    Dukungan
                  </p>
                  {support.map((item) => (
                    <div key={item.id} className="inline-block max-w-fit">
                      <Link to={item.link}>
                        <Text4
                          className="hover:underline text-white cursor-pointer"
                          text={item.inaTitle}
                        />
                      </Link>
                    </div>
                  ))}
                </div>
              </section>
              <div className="mt-[1rem] lg:mt-[0rem] w-full flex flex-col gap-[1rem]">
                <p className="heading-5-style typo-dark-primary font-semibold">
                  Temui Kami
                </p>
                <div className="w-full flex flex-row lg:flex-row-reverse gap-[1rem]">
                  <section className="w-[50%] flex lg:justify-end">
                    <Link to={ADDRESS_GMAPS_LINK}>
                      <img
                        src="https://ik.imagekit.io/didigi/jasa_renovasi_rumah_di_bekasi/jasa-renovasi-di-bekasi_arsinesia-map-2.webp"
                        alt={SITE_URL}
                        width={800} // lebar asli
                        height={450} // tinggi asli
                        className="w-[10rem] lg:w-[7rem] xl:w-[10rem] rounded-lg"
                      />
                    </Link>
                  </section>

                  <section className="w-[50%] flex flex-col gap-[1rem]">
                    {contacts
                      .filter((contact) => contact.id !== 1)
                      .map((contact) => (
                        <div
                          key={contact.id}
                          className="flex flex-row items-start gap-2"
                        >
                          <div>{contact.icon}</div>
                          <a
                            className="hover:underline typo-dark-primary cursor-pointer font-semibold text-[12px] lg:text-[12px]"
                            href={contact.link}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {contact.inaTitle}
                          </a>
                        </div>
                      ))}
                    <div className="w-full hidden lg:flex">
                      {contacts
                        .filter((contact) => contact.id === 1)
                        .map((contact) => (
                          <div
                            key={contact.id}
                            className="flex flex-row items-start gap-2"
                          >
                            <div>{contact.icon}</div>
                            <Link target="_blank" to={contact.link}>
                              <Text4
                                className="hover:underline typo-dark-primary cursor-pointer text-bold"
                                text={contact.inaTitle}
                              />
                            </Link>
                          </div>
                        ))}
                    </div>
                  </section>
                </div>
                <div className="flex flex-row items-start gap-2">
                  <div>
                    <Mails className="h-4 w-4 stroke-gray-300" />
                  </div>
                  <Link target="_blank" to={`mailto:${EMAIL_ADDRESS}`}>
                    <Text4
                      className="hover:underline typo-dark-primary cursor-pointer text-bold"
                      text={EMAIL_ADDRESS}
                    />
                  </Link>
                </div>
                {maps.map((item) => (
                  <div
                    key={item.id}
                    className="lg:hidden flex flex-col items-start gap-2"
                  >
                    <Text4
                      className="hover:underline typo-dark-primary cursor-pointer text-bold"
                      text={item.address}
                    />
                  </div>
                ))}
                <section className="pt-[2rem] lg:flex lg:self-end gap-4">
                  <div className="flex flex-row gap-2">
                    {certified.map((item) => (
                      <img
                        key={item.id}
                        className="min-w-[3rem] h-auto rounded-lg"
                        src={item.src}
                        alt={item.alt}
                        // width={48}
                        height={Math.round(48 / (561 / 264))} // ≈ 23
                      />
                    ))}
                  </div>
                </section>
              </div>
            </section>
          </div>
          <div className="mt-[1rem] w-full flex flex-col lg:flex-row gap-2 lg:items-center justify-center md:mt-[10rem] lg:justify-center lg:mt-[2rem] ">
            <div className="flex flex-row gap-2">
              <Link to="/">
                <Text5
                  className="typo-dark-primary typo-theme-base-hover-secondary"
                  text={AUTHOR}
                />
              </Link>
            </div>
            <Text5
              className="typo-dark-primary typo-theme-base-hover-secondary"
              text={"Hak Cipta Dilindungi Undang-Undang."}
            />
            <div className="flex flex-row gap-1">
              <Text5 className="text-[11px] typo-dark-primary" text="© 2025 " />
              <Link target="_blank" to="https://didigi.co/">
                <Text5
                  className="text-[11px] typo-dark-primary typo-theme-base-hover-secondary"
                  text="desain website oleh didigi.co"
                />
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* <div className="py-[30rem] bg-red-400">MAMAMAA</div> */}
    </>
  );
};
